module.exports = __webpack_public_path__ + "img/func-intro-1x.e0c8370a.png";